import { render } from "./tkinfo.vue?vue&type=template&id=559edf32&scoped=true"
import script from "./tkinfo.vue?vue&type=script&lang=js"
export * from "./tkinfo.vue?vue&type=script&lang=js"

import "./tkinfo.vue?vue&type=style&index=0&id=559edf32&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559edf32"]])

export default __exports__